import {
  useRemoveSharesFromCollectionMutation,
  RemoveSharesFromCollectionMutation,
  ShareListItemFragment,
} from '@sketch/gql-types'
import { removeSharesFromCollection, addSharesToProject } from './utils'
import { readShareWithProjectFragment } from 'modules/projects/operations/utils/project.cache'

interface UseRemoveSharesFromCollectionProps {
  projectIdentifier: string
  onCompleted?: (data: RemoveSharesFromCollectionMutation) => void
}

export const useRemoveSharesFromCollection = ({
  projectIdentifier,
  onCompleted,
}: UseRemoveSharesFromCollectionProps) => {
  const [mutation] = useRemoveSharesFromCollectionMutation({
    onCompleted,
    onError: 'show-toast',
  })

  const mutationWithCacheUpdate: typeof mutation = (options = {}) => {
    const shareIdentifiers = options.variables?.shareIdentifiers ?? []

    return mutation({
      ...options,
      update: (cache, { data }) => {
        if (!data) {
          return
        }

        const { collection } = data.removeSharesFromCollection

        const shares = shareIdentifiers
          .map(identifier => readShareWithProjectFragment(cache, identifier))
          .filter(maybeShare => maybeShare !== null) as ShareListItemFragment[]

        // Remove the shares from the collection
        removeSharesFromCollection({
          cache,
          projectIdentifier,
          collectionIdentifier: collection.identifier,
          sharesToRemove: shares,
        })

        addSharesToProject(cache, projectIdentifier, shares)
      },
    })
  }

  return mutationWithCacheUpdate
}
